const selectServiceType = {
  serviceType: 'Service',
  department: 'Department:',
  brand: 'Brand:',
  description: 'Description:',
  place: 'Place:',
  reference: 'Reference:',
  serviceTypeTitle: 'Service type',
  onTime: 'On time',
  overdue: 'Overdue',
  noService: 'No service',
  mandatory: 'Mandatory service',
  expiration: 'Expiration date:',
  daysRemaining: 'days remaining',
  daysOverdue: 'days overdue',
  dayRemaining: 'day remaining',
  dayOverdue: 'day overdue',
  buttonGoBack: 'go back',
  lastPerform: 'Last performed:',
  onDemand: 'On-demand service'
};

export default selectServiceType;